module.exports = __webpack_public_path__ + "img/xflogo.d882db89.png";